export default function TableShimmer({
  columns = 5,
  rows = 8
}: {
  columns?: number;
  rows?: number;
}) {
  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-lg">
      <div className="max-w-full max-h-screen h-full overflow-auto rounded-lg">
        <table
          className="min-w-full border-separate relative"
          style={{ borderSpacing: 0 }}
        >
          <thead>
            <tr>
              {Array.from({ length: columns }).map((_, colIdx) => (
                <th
                  key={colIdx}
                  className="sticky top-0 border-b border-gray-200 whitespace-nowrap bg-white px-3 py-4 text-left text-xs font-semibold text-gray-900"
                >
                  <div className="animate-pulse w-24 h-4 bg-gray-200 rounded-lg"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {Array.from({ length: rows }).map((_, rowIdx) => (
              <tr
                key={rowIdx}
                className="overflow-visible"
              >
                {Array.from({ length: columns }).map((_, colIdx) => (
                  <td
                    key={colIdx}
                    className="border-b border-gray-200 px-3 py-4 text-xs text-gray-500"
                  >
                    <div className="animate-pulse w-full h-4 bg-gray-200 rounded-lg"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
